import { Allotment } from 'allotment';
import { LayoutLeftPane } from './coding-tab-contents/LayoutLeftPane';
import { LayoutRightPane } from './coding-tab-contents/LayoutRightPane';
import { Box } from '@mui/material';
import 'allotment/dist/style.css';

export function CodingTabContent() {
  return (
    <Box
      className="CodingTabContent-root"
      component={Allotment}
      sx={{
        '& .LayoutLeftPane-root': {
          // pr: '4px',
        },
        '& .LayoutRightPane-root': {
          // pl: '4px',
        },
      }}
    >
      <Allotment.Pane minSize={100}>
        <LayoutLeftPane />
      </Allotment.Pane>
      <Allotment.Pane minSize={100}>
        <LayoutRightPane />
      </Allotment.Pane>
    </Box>
  );
}
